const PokerSite = (props) => {
    return (
        <img src={props.pokerSite.icon.url} alt={props.pokerSite.icon.alt} width="90" height="60" />
    )
}

export default PokerSite